<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_status === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มช่องทางการชำระเงินเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขช่องทางการชำระเงินเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete === true">ลบช่องทางการชำระเงินเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <div class="mb-3">
                    <h2>ช่องทางการชำระเงิน</h2>
                </div>
                <div class="text-right mb-3">
                    <v-btn height="65" width="20%" color="#28ab28" class="white--text" @click="openPaymentadd()">
                        เพิ่มการชำระเงิน
                    </v-btn>
                </div>
                <div>
                    <v-card class="mb-3" v-for="(detail,index) in data" :key="index">
                        <div class="pa-3 list_content_payment_list d-flex align-center">
                            <div class="img_payment_content_payment_list">
                                <img :src="detail.image_qrcode">
                            </div>
                            <div class="grid_detail_content_payment_list">
                                <div>
                                    <div>ชื่อธนาคาร : {{ detail.bank_name }}</div>
                                    <div>เลขบัญชี : {{ detail.bank_code }}</div>
                                    <div>ชื่อบัญชี : {{ detail.account_name }}</div>
                                </div>
                                <div class="flex-column d-flex align-end">
                                    <div>
                                        แสดงหน้าเว็บไซต์
                                    </div>
                                    <div class="d-flex">
                                        <v-switch class="ma-0 pa-0" hide-details="true" width="10" color="success" @click="changeStatus(detail.id)" v-model="detail.status"></v-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="action_content_payment_list">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" width="50">mdi-dots-vertical</v-icon>
                                    </template>
                                    <v-list>
                                        <v-list-item class="cursor_content_payment_list" @click="paymentDetail(detail.id)">
                                            <v-list-item-title>แก้ไขช่องทางการชำระเงิน</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item class="cursor_content_payment_list" @click="confirmPaymentDelete(detail.id)">
                                            <v-list-item-title>ลบช่องทางการชำระเงิน</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </v-card>
        <!-- เพิ่ม -->
        <v-dialog v-model="open_payment_add" persistent max-width="600px">
            <v-card>
                <v-form ref="form_add" @submit.prevent="addPayment()">
                    <v-card-title class="justify-space-between">
                        <div>
                            เพิ่มช่องทางการชำระเงิน
                        </div>
                        <div class="cursor_content_payment_list" @click="open_payment_add = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-img height="330" max-width="280" v-if="imagePreviewURL" :src="imagePreviewURL" class="image_preview_content_payment_list"></v-img>
                                <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="payment_add.image" label="เพิ่มรูปภาพ QR Code" @change="onFileChange" :rules="[v => !!v || 'กรุณาเพิ่มรูปภาพ QR Code']" required></v-file-input>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="ชื่อธนาคาร" v-model="payment_add.bank_name" :rules="[v => !!v || 'กรุณากรอกชื่อธนาคาร']" hide-details="auto" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="เลขบัญชี" type="tel" @keypress="isNumberBank($event)" onpaste="return false" v-model="payment_add.bank_code" :rules="[v => !!v || 'กรุณากรอกเลขบัญชี']" hide-details="auto" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="ชื่อบัญชี" v-model="payment_add.account_name" :rules="[v => !!v || 'กรุณากรอกชื่อบัญชี']" hide-details="auto" required outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn type="submit" color="#28ab28" class="white--text" width="50%" height="60">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- แก้ไข -->
        <v-dialog v-model="open_payment_edit" persistent max-width="600px">
            <div v-if="loading_page_detail === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_detail === false">
                <v-form ref="form_edit" @submit.prevent="editPayment()">
                    <v-card-title class="justify-space-between">
                        <div>
                            แก้ไขช่องทางการชำระเงิน
                        </div>
                        <div class="cursor_content_payment_list" @click="open_payment_edit = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>

                        <v-row>
                            <v-col cols="12">
                                <v-img height="330" max-width="280" v-if="imagePreviewURL" :src="imagePreviewURL" class="image_preview_content_payment_list"></v-img>
                                <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="payment_edit.image" label="เพิ่มรูปภาพ QR Code" @change="onFileChange"></v-file-input>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="ชื่อธนาคาร" v-model="payment_edit.bank_name" :rules="[v => !!v || 'กรุณากรอกชื่อธนาคาร']" hide-details="auto" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="เลขบัญชี" type="tel" @keypress="isNumberBank($event)" onpaste="return false" v-model="payment_edit.bank_code" :rules="[v => !!v || 'กรุณากรอกเลขบัญชี']" hide-details="auto" required outlined></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="ชื่อบัญชี" v-model="payment_edit.account_name" :rules="[v => !!v || 'กรุณากรอกชื่อบัญชี']" hide-details="auto" required outlined></v-text-field>
                            </v-col>
                        </v-row>

                    </v-card-text>

                    <v-card-actions class="justify-center">
                        <v-btn type="submit" color="#28ab28" class="white--text" width="50%" height="60">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- ลบ -->
        <v-dialog v-model="open_payment_delete" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    คำเตือน
                </v-card-title>

                <v-card-text>
                    ต้องการลบช่องทางการชำระเงินนี้ ใช่หรือไม่ ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" height="50" @click="deletePayment()">
                        บันทึก
                    </v-btn>
                    <v-btn color="error" height="50" @click="cancelDeletePayment()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script src="@/previewimage.js"></script><script>
import before_image from '@/assets/picture.png'
import contentpayment from '@/api/content/contentsetting/contentpayment.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_page_detail: true,
            alert_show_status: false,
            alert_show_add: false,
            alert_show_edit: false,
            alert_show_delete: false,
            open_payment_add: false,
            open_payment_edit: false,
            open_payment_delete: false,
            imagePreviewURL: before_image,
            payment_add: {
                image: null,
                bank_name: null,
                bank_code: null,
                account_name: null,
            },
            payment_edit: {
                id: null,
                image: null,
                bank_name: null,
                bank_code: null,
                account_name: null,
            },
            data: []
        }
    },
    methods: {
        async onFileChange(payload) {
            const file = payload
            if (file) {
                this.imagePreviewURL = URL.createObjectURL(file)
                URL.revokeObjectURL(file)
            } else {
                this.imagePreviewURL = before_image
            }
        },
        async paymentList() {
            this.loading_page = true
            contentpayment.paymentList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.payment_list
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async isNumberBank(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async changeStatus(id) {
            contentpayment.changeStatusPayment(id).then((response) => {
                if (response.data.successful === true) {
                    this.alert_show_status = true
                    setTimeout(() => this.alert_show_status = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openPaymentadd() {
            this.imagePreviewURL = before_image
            this.payment_add = {
                image: null,
                bank_name: null,
                bank_code: null,
                account_name: null,
            }
            this.open_payment_add = true
        },
        async addPayment() {
            if (this.$refs.form_add.validate()) {
                this.open_payment_add = false
                this.loading_page = true
                let data = new FormData()
                data.append('image', this.payment_add.image)
                data.append('bank_name', this.payment_add.bank_name)
                data.append('bank_code', this.payment_add.bank_code)
                data.append('account_name', this.payment_add.account_name)

                contentpayment.addPayment(data).then((response) => {
                    if (response.data.successful === true) {
                        this.payment_add = {
                            image: null,
                            bank_name: null,
                            bank_code: null,
                            account_name: null,
                        }
                        this.paymentList()
                        this.alert_show_add = true
                        setTimeout(() => this.alert_show_add = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async paymentDetail(id) {
            this.loading_page_detail = true
            this.open_payment_edit = true
            contentpayment.paymentDetail(id).then((response) => {
                if (response.data.successful === true) {
                    this.payment_edit = {
                        id: response.data.detail.id,
                        image: null,
                        bank_name: response.data.detail.bank_name,
                        bank_code: response.data.detail.bank_code,
                        account_name: response.data.detail.account_name,
                    }
                    this.imagePreviewURL = response.data.detail.image
                    this.loading_page_detail = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async editPayment() {
            if (this.$refs.form_edit.validate()) {
                this.open_payment_edit = false
                this.loading_page = true
                let data = new FormData()
                data.append('image', this.payment_edit.image)
                data.append('bank_name', this.payment_edit.bank_name)
                data.append('bank_code', this.payment_edit.bank_code)
                data.append('account_name', this.payment_edit.account_name)
                contentpayment.editPayment(this.payment_edit.id, data).then((response) => {
                    if (response.data.successful === true) {
                        this.payment_edit = {
                            id: null,
                            image: null,
                            bank_name: null,
                            bank_code: null,
                            account_name: null,
                        }
                        this.paymentList()
                        this.alert_show_edit = true
                        setTimeout(() => this.alert_show_edit = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async confirmPaymentDelete(id) {
            this.open_payment_delete = true
            this.edit_id = id
        },
        async cancelDeletePayment() {
            this.open_payment_delete = false
            this.edit_id = null
        },
        async deletePayment() {
            this.open_payment_delete = false
            this.loading_page = true
            contentpayment.deletePayment(this.edit_id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = null
                    this.paymentList()
                    this.alert_show_delete = true
                    setTimeout(() => this.alert_show_delete = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },
    mounted() {
        this.paymentList()
    }
}
</script>

<style scoped>
.list_content_payment_list {
    position: relative;
}

.img_payment_content_payment_list {
    width: 190px;
}

.img_payment_content_payment_list>img {
    max-width: 100%;
}

.grid_detail_content_payment_list {
    width: 100%;
    padding: 0 10px;
    display: grid;
    grid-template-columns: 70% 30%;
}

.action_content_payment_list {
    position: absolute;
    top: 0;
    right: 0;
}

.cursor_content_payment_list {
    cursor: pointer;
}

.image_preview_content_payment_list {
    margin: auto;
}
</style>
